import React from 'react';
import styled from 'styled-components';
import { config } from '@keytrade/functions';
const { list: colors } = config.colors;
const { getFont } = config.fonts;

const NoResult = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.BlueSmoke};
  border-radius: 16px;
`;

const NoResultWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const NoResultTitle = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => getFont(theme, 'semiBold')};
  color: ${colors.BlueDark};
`;

const NoResultText = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => getFont(theme, 'regular')};
  color: ${colors.BlueMoon};
`;
export type NoDataNotificationType = {
  title: string;
  text: string;
  icon?: any;
};

const NoDataNotification: React.FC<NoDataNotificationType> = ({
  title,
  text,
  icon,
}) => {
  return (
    <NoResult>
      <NoResultWrapper>
        {icon}
        <NoResultTitle>{title}</NoResultTitle>
        <NoResultText>{text}</NoResultText>
      </NoResultWrapper>
    </NoResult>
  );
};

export default NoDataNotification;
